module.exports = __webpack_public_path__ + "img/empty.ff72556d.png";